import React, { useEffect } from 'react'
import aos from "aos"
import "aos/dist/aos.css"

const Skills = () => {

  useEffect(()=>{
    aos.init({duration:3000});
    });
  return (
    <section className="skills-area page-section scroll-to-page" id="skills">
    <div className="custom-container">
      <div className="skills-content content-width">
        <div className="section-header" style={{marginTop:"49px"}}>
          <h4 className="subtitle scroll-animation" data-animation="fade_from_bottom" style={{marginBottom:"0px"}}>
            <i className="las la-shapes" /> my skills
          </h4>
          <h1 className="scroll-animation" data-aos="fade-up"
     data-aos-anchor-placement="top-bottom"  data-animation="fade_from_bottom">My <span>Skills</span></h1>
        </div>
        <div className="row skills text-center" >
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_left">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/html5-logo.png" style={{height:'67px'}} alt="Figma" />
                <h5 className="percent" style={{color:"#00693e"}}>HTML</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/CSS.png" alt="Framer" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>CSS</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_top">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/JS.png" alt="Webflow" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>JAVASCRIPT</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_right">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/bootstrap-logo.png" alt="React" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>BOOTSTRAP</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_left">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/jquery+logo.png" alt="WordPress" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>JQUERY</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/PHP.png" alt="Laravel/PHP" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>PHP</h5>
              </div>
              {/* <p className="name">PHP</p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/mysql.png" alt="Laravel/PHP" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>MYSQL</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/codeigniter.png" alt="Laravel/PHP" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>CODEIGNITER</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/logo-reactjs.jpg" alt="Laravel/PHP" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>REACT.JS</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/Node.png" alt="Laravel/PHP" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>NODE.JS</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/Express.png" alt="Laravel/PHP" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>EXPRESS.JS</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/MongoDB.png" alt="Laravel/PHP" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>MONGO DB</h5>
              </div>
              {/* <p className="name"></p> */}
            </div>
          </div>
          {/* <div className="col-md-3 scroll-animation" data-aos="zoom-in-down" data-animation="fade_from_bottom">
            <div className="skill">
              <div className="skill-inner">
                <img src="assets/images/RN.png" alt="Laravel/PHP" style={{height:'67px'}} />
                <h5 className="percent" style={{color:"#00693e"}}>55%</h1>
              </div>
              <p className="name">REACT NATIVE</p>
            </div>
          </div> */}


        </div>
      </div>
    </div>
  </section>
  )
}

export default Skills